// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Artist
 */
export interface Artist {
    /**
     * 
     * @type {ArtistAttribute}
     * @memberof Artist
     */
    attribute: ArtistAttribute;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    backgroundColor: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    copyright: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    coverImage: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    icon: string;
    /**
     * 
     * @type {number}
     * @memberof Artist
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof Artist
     */
    openDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    openDateString?: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    pageType?: ArtistPageTypeEnum;
    /**
     * 
     * @type {Array<Plan>}
     * @memberof Artist
     */
    planList?: Array<Plan>;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof Artist
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    subName: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    tag?: string;
    /**
     * 
     * @type {string}
     * @memberof Artist
     */
    type: ArtistTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ArtistPageTypeEnum {
    NORMAL = 'NORMAL',
    NORMAL2 = 'NORMAL2',
    SPECIAL = 'SPECIAL',
    SPECIALLIST = 'SPECIAL_LIST'
}
/**
    * @export
    * @enum {string}
    */
export enum ArtistTypeEnum {
    OTHER = 'OTHER',
    VTUBER = 'VTUBER',
    YOUTUBER = 'YOUTUBER',
    TALENT = 'TALENT',
    SPORTS = 'SPORTS',
    GAME = 'GAME',
    ANIME = 'ANIME',
    ENTERTAINER = 'ENTERTAINER',
    COMICS = 'COMICS',
    ARTIST = 'ARTIST',
    SINGER = 'SINGER',
    VOICEACTOR = 'VOICE_ACTOR',
    CHARACTER = 'CHARACTER',
    LIVER = 'LIVER',
    ILLUSTRATOR = 'ILLUSTRATOR',
    EVENT = 'EVENT'
}

/**
 * 
 * @export
 * @interface ArtistAttribute
 */
export interface ArtistAttribute {
    /**
     * 
     * @type {Array<ArtistAttributeSns>}
     * @memberof ArtistAttribute
     */
    snsList?: Array<ArtistAttributeSns>;
}
/**
 * 
 * @export
 * @interface ArtistAttributeSns
 */
export interface ArtistAttributeSns {
    /**
     * 
     * @type {string}
     * @memberof ArtistAttributeSns
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistAttributeSns
     */
    type?: ArtistAttributeSnsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ArtistAttributeSns
     */
    url?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ArtistAttributeSnsTypeEnum {
    YOUTUBE = 'YOUTUBE',
    TIKTOK = 'TIKTOK',
    FACEBOOK = 'FACEBOOK',
    LINE = 'LINE',
    OFFICIAL = 'OFFICIAL',
    NICONICO = 'NICONICO',
    INSTAGRAM = 'INSTAGRAM',
    TWITCH = 'TWITCH',
    OTHER = 'OTHER',
    TWITTER = 'TWITTER'
}

/**
 * 
 * @export
 * @interface Banner
 */
export interface Banner {
    /**
     * 
     * @type {Date}
     * @memberof Banner
     */
    closeDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    closeDateString?: string;
    /**
     * 
     * @type {number}
     * @memberof Banner
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    img: string;
    /**
     * 
     * @type {Date}
     * @memberof Banner
     */
    openDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    openDateString?: string;
    /**
     * 
     * @type {number}
     * @memberof Banner
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    url: string;
}
/**
 * 
 * @export
 * @interface EmailPass
 */
export interface EmailPass {
    /**
     * 
     * @type {string}
     * @memberof EmailPass
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPass
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPass
     */
    pass?: string;
}
/**
 * 
 * @export
 * @interface FormData
 */
export interface FormData {
    /**
     * 
     * @type {string}
     * @memberof FormData
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof FormData
     */
    enctype: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FormData
     */
    hiddenInput: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FormData
     */
    method: string;
}
/**
 * 
 * @export
 * @interface Goods
 */
export interface Goods {
    /**
     * 
     * @type {number}
     * @memberof Goods
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Goods
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Goods
     */
    type: string;
}
/**
 * 
 * @export
 * @interface LoginStatus
 */
export interface LoginStatus {
    /**
     * 
     * @type {boolean}
     * @memberof LoginStatus
     */
    securitySafe: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginStatus
     */
    session: string;
    /**
     * 
     * @type {number}
     * @memberof LoginStatus
     */
    userId: number;
}
/**
 * 
 * @export
 * @interface Maker
 */
export interface Maker {
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    contactName: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    contactName2?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    contactName3?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Maker
     */
    contractFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    email2?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    email3?: string;
    /**
     * 
     * @type {number}
     * @memberof Maker
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    kana: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    paymentSite?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    tel: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    updatedAtString?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    updaterName: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Maker
     */
    zip: string;
}
/**
 * 
 * @export
 * @interface MakerItem
 */
export interface MakerItem {
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    adobe?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    adobe2?: string;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    calibrationPrice: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    color?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MakerItem
     */
    favoriteFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MakerItem
     */
    grossOrderFlag?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    image2?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    image3?: string;
    /**
     * 
     * @type {Maker}
     * @memberof MakerItem
     */
    maker: Maker;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    memo2?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    memo3?: string;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    minimumOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    minimumOrderPrice: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    oneFixedPrice: number;
    /**
     * 
     * @type {Array<Order>}
     * @memberof MakerItem
     */
    orderList?: Array<Order>;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    otherPrice: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    otherPrice2?: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    otherPrice2Name?: string;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    otherPrice3?: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    otherPrice3Name?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    otherPriceName?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    pdf?: string;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price10?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price100?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price1000?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price200?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price30?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price300?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price50?: number;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    price500?: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    printMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    subName?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    tag?: string;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    temporaryPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    type: MakerItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    typeString?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    updatedAtString?: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    updaterName: string;
    /**
     * 
     * @type {string}
     * @memberof MakerItem
     */
    url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MakerItem
     */
    usedFlag?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MakerItem
     */
    versionPrice: number;
}

/**
    * @export
    * @enum {string}
    */
export enum MakerItemTypeEnum {
    FOOD = 'FOOD',
    CLOTHING = 'CLOTHING',
    EXPENDABLES = 'EXPENDABLES',
    TABLEWARE = 'TABLEWARE',
    SUNDRIES = 'SUNDRIES',
    OTHER = 'OTHER'
}

/**
 * 
 * @export
 * @interface ModelAndView
 */
export interface ModelAndView {
    /**
     * 
     * @type {boolean}
     * @memberof ModelAndView
     */
    empty?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ModelAndView
     */
    model?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ModelAndView
     */
    modelMap?: { [key: string]: object; };
    /**
     * 
     * @type {boolean}
     * @memberof ModelAndView
     */
    reference?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelAndView
     */
    status?: ModelAndViewStatusEnum;
    /**
     * 
     * @type {View}
     * @memberof ModelAndView
     */
    view?: View;
    /**
     * 
     * @type {string}
     * @memberof ModelAndView
     */
    viewName?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ModelAndViewStatusEnum {
    _100CONTINUE = '100 CONTINUE',
    _101SWITCHINGPROTOCOLS = '101 SWITCHING_PROTOCOLS',
    _102PROCESSING = '102 PROCESSING',
    _103CHECKPOINT = '103 CHECKPOINT',
    _200OK = '200 OK',
    _201CREATED = '201 CREATED',
    _202ACCEPTED = '202 ACCEPTED',
    _203NONAUTHORITATIVEINFORMATION = '203 NON_AUTHORITATIVE_INFORMATION',
    _204NOCONTENT = '204 NO_CONTENT',
    _205RESETCONTENT = '205 RESET_CONTENT',
    _206PARTIALCONTENT = '206 PARTIAL_CONTENT',
    _207MULTISTATUS = '207 MULTI_STATUS',
    _208ALREADYREPORTED = '208 ALREADY_REPORTED',
    _226IMUSED = '226 IM_USED',
    _300MULTIPLECHOICES = '300 MULTIPLE_CHOICES',
    _301MOVEDPERMANENTLY = '301 MOVED_PERMANENTLY',
    _302FOUND = '302 FOUND',
    _302MOVEDTEMPORARILY = '302 MOVED_TEMPORARILY',
    _303SEEOTHER = '303 SEE_OTHER',
    _304NOTMODIFIED = '304 NOT_MODIFIED',
    _305USEPROXY = '305 USE_PROXY',
    _307TEMPORARYREDIRECT = '307 TEMPORARY_REDIRECT',
    _308PERMANENTREDIRECT = '308 PERMANENT_REDIRECT',
    _400BADREQUEST = '400 BAD_REQUEST',
    _401UNAUTHORIZED = '401 UNAUTHORIZED',
    _402PAYMENTREQUIRED = '402 PAYMENT_REQUIRED',
    _403FORBIDDEN = '403 FORBIDDEN',
    _404NOTFOUND = '404 NOT_FOUND',
    _405METHODNOTALLOWED = '405 METHOD_NOT_ALLOWED',
    _406NOTACCEPTABLE = '406 NOT_ACCEPTABLE',
    _407PROXYAUTHENTICATIONREQUIRED = '407 PROXY_AUTHENTICATION_REQUIRED',
    _408REQUESTTIMEOUT = '408 REQUEST_TIMEOUT',
    _409CONFLICT = '409 CONFLICT',
    _410GONE = '410 GONE',
    _411LENGTHREQUIRED = '411 LENGTH_REQUIRED',
    _412PRECONDITIONFAILED = '412 PRECONDITION_FAILED',
    _413PAYLOADTOOLARGE = '413 PAYLOAD_TOO_LARGE',
    _413REQUESTENTITYTOOLARGE = '413 REQUEST_ENTITY_TOO_LARGE',
    _414URITOOLONG = '414 URI_TOO_LONG',
    _414REQUESTURITOOLONG = '414 REQUEST_URI_TOO_LONG',
    _415UNSUPPORTEDMEDIATYPE = '415 UNSUPPORTED_MEDIA_TYPE',
    _416REQUESTEDRANGENOTSATISFIABLE = '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417EXPECTATIONFAILED = '417 EXPECTATION_FAILED',
    _418IAMATEAPOT = '418 I_AM_A_TEAPOT',
    _419INSUFFICIENTSPACEONRESOURCE = '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420METHODFAILURE = '420 METHOD_FAILURE',
    _421DESTINATIONLOCKED = '421 DESTINATION_LOCKED',
    _422UNPROCESSABLEENTITY = '422 UNPROCESSABLE_ENTITY',
    _423LOCKED = '423 LOCKED',
    _424FAILEDDEPENDENCY = '424 FAILED_DEPENDENCY',
    _425TOOEARLY = '425 TOO_EARLY',
    _426UPGRADEREQUIRED = '426 UPGRADE_REQUIRED',
    _428PRECONDITIONREQUIRED = '428 PRECONDITION_REQUIRED',
    _429TOOMANYREQUESTS = '429 TOO_MANY_REQUESTS',
    _431REQUESTHEADERFIELDSTOOLARGE = '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UNAVAILABLEFORLEGALREASONS = '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500INTERNALSERVERERROR = '500 INTERNAL_SERVER_ERROR',
    _501NOTIMPLEMENTED = '501 NOT_IMPLEMENTED',
    _502BADGATEWAY = '502 BAD_GATEWAY',
    _503SERVICEUNAVAILABLE = '503 SERVICE_UNAVAILABLE',
    _504GATEWAYTIMEOUT = '504 GATEWAY_TIMEOUT',
    _505HTTPVERSIONNOTSUPPORTED = '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VARIANTALSONEGOTIATES = '506 VARIANT_ALSO_NEGOTIATES',
    _507INSUFFICIENTSTORAGE = '507 INSUFFICIENT_STORAGE',
    _508LOOPDETECTED = '508 LOOP_DETECTED',
    _509BANDWIDTHLIMITEXCEEDED = '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NOTEXTENDED = '510 NOT_EXTENDED',
    _511NETWORKAUTHENTICATIONREQUIRED = '511 NETWORK_AUTHENTICATION_REQUIRED'
}

/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {Date}
     * @memberof News
     */
    closeDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    closeDateString?: string;
    /**
     * 
     * @type {number}
     * @memberof News
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    message: string;
    /**
     * 
     * @type {Date}
     * @memberof News
     */
    openDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    openDateString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof News
     */
    openFlag: boolean;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    title: string;
}
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    assumedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    endDateTimeString?: string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    fixedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    lastFlag?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    makerItemCount?: number;
    /**
     * 
     * @type {Array<MakerItem>}
     * @memberof Order
     */
    makerItemList?: Array<MakerItem>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    openDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    payAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    payAtString?: string;
    /**
     * 
     * @type {Plan}
     * @memberof Order
     */
    plan?: Plan;
    /**
     * 
     * @type {Planning}
     * @memberof Order
     */
    planning?: Planning;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    preTaxPrice: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    shipDate: string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    spareCount2?: number;
}
/**
 * 
 * @export
 * @interface Plan
 */
export interface Plan {
    /**
     * 
     * @type {Artist}
     * @memberof Plan
     */
    artist: Artist;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    attention?: string;
    /**
     * 
     * @type {Order}
     * @memberof Plan
     */
    currentOrder?: Order;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof Plan
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    name: string;
    /**
     * 
     * @type {Order}
     * @memberof Plan
     */
    nextOrder?: Order;
    /**
     * 
     * @type {Date}
     * @memberof Plan
     */
    openDate?: Date;
    /**
     * 
     * @type {Array<Order>}
     * @memberof Plan
     */
    orderList?: Array<Order>;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    period: number;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    preTaxPrice: number;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    sort: number;
}
/**
 * 
 * @export
 * @interface PlanOrderGoods
 */
export interface PlanOrderGoods {
    /**
     * 
     * @type {number}
     * @memberof PlanOrderGoods
     */
    count: number;
    /**
     * 
     * @type {Goods}
     * @memberof PlanOrderGoods
     */
    goods: Goods;
}
/**
 * 
 * @export
 * @interface PlanOrderHistory
 */
export interface PlanOrderHistory {
    /**
     * 
     * @type {number}
     * @memberof PlanOrderHistory
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    deliveryDateString?: string;
    /**
     * 
     * @type {Order}
     * @memberof PlanOrderHistory
     */
    order: Order;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    other?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    paidAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    paymentId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    paymentMethod: PlanOrderHistoryPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    paymentStatus: PlanOrderHistoryPaymentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PlanOrderHistory
     */
    preTaxPrice: number;
    /**
     * 
     * @type {number}
     * @memberof PlanOrderHistory
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipAddress2?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipDestName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipNumberString?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipSrcName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipTel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanOrderHistory
     */
    shipZip?: string;
    /**
     * 
     * @type {User}
     * @memberof PlanOrderHistory
     */
    user: User;
}

/**
    * @export
    * @enum {string}
    */
export enum PlanOrderHistoryPaymentMethodEnum {
    NONE = 'NONE',
    CARD = 'CARD',
    GMOAB = 'GMOAB'
}
/**
    * @export
    * @enum {string}
    */
export enum PlanOrderHistoryPaymentStatusEnum {
    BEFORE = 'BEFORE',
    CANCEL = 'CANCEL',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    WAITING = 'WAITING',
    SHIPSTART = 'SHIPSTART',
    COMPLETEMAIL = 'COMPLETEMAIL'
}

/**
 * 
 * @export
 * @interface Planning
 */
export interface Planning {
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    artistName?: string;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    deliveryDateString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Planning
     */
    fixedFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    fixerName?: string;
    /**
     * 
     * @type {number}
     * @memberof Planning
     */
    grossProfitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof Planning
     */
    grossProfitRate?: number;
    /**
     * 
     * @type {number}
     * @memberof Planning
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    memo?: string;
    /**
     * 
     * @type {number}
     * @memberof Planning
     */
    minimumGuarantee: number;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    name?: string;
    /**
     * 
     * @type {Array<Order>}
     * @memberof Planning
     */
    planOrderList?: Array<Order>;
    /**
     * 
     * @type {Array<PlanningMakerItem>}
     * @memberof Planning
     */
    planningMakerItemList?: Array<PlanningMakerItem>;
    /**
     * 
     * @type {number}
     * @memberof Planning
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof Planning
     */
    spareCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    updatedAtString?: string;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    updaterName: string;
    /**
     * 
     * @type {boolean}
     * @memberof Planning
     */
    wcheckFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Planning
     */
    wcheckerName?: string;
}
/**
 * 
 * @export
 * @interface PlanningMakerItem
 */
export interface PlanningMakerItem {
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    adjustmentPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    attention?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    cost?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    costAdjustmentPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    deliveryDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    fixedCalibrationPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    fixedOtherPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    fixedPlanningPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    fixedPostageCalibrationPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    fixedPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    fixedVersionPrice?: number;
    /**
     * 
     * @type {MakerItem}
     * @memberof PlanningMakerItem
     */
    makerItem: MakerItem;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    memo2?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    orderDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    ordererName?: string;
    /**
     * 
     * @type {Planning}
     * @memberof PlanningMakerItem
     */
    planning?: Planning;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    spareCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    spareCount2?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    spareCount2Cost?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    spareCountCost?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    sumFixedPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    userDeliveryDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    warehousedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlanningMakerItem
     */
    warehousedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanningMakerItem
     */
    warehousingCount?: number;
}
/**
 * 
 * @export
 * @interface Redirect
 */
export interface Redirect {
    /**
     * 
     * @type {string}
     * @memberof Redirect
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof Redirect
     */
    ttl?: number;
    /**
     * 
     * @type {string}
     * @memberof Redirect
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    address2: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    birthday: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    createdAtString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    deleteFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    gender: UserGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    kana?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    ngMailFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ngPaymentMethod?: UserNgPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    otherPrefecture?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    paymentMethod?: UserPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    prefecture?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    tel: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    updatedAtString?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    zip: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserGenderEnum {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    UNKNOWN = 'UNKNOWN'
}
/**
    * @export
    * @enum {string}
    */
export enum UserNgPaymentMethodEnum {
    NONE = 'NONE',
    CARD = 'CARD',
    GMOAB = 'GMOAB'
}
/**
    * @export
    * @enum {string}
    */
export enum UserPaymentMethodEnum {
    NONE = 'NONE',
    CARD = 'CARD',
    GMOAB = 'GMOAB'
}

/**
 * 
 * @export
 * @interface UserPlan
 */
export interface UserPlan {
    /**
     * 
     * @type {number}
     * @memberof UserPlan
     */
    count: number;
    /**
     * 
     * @type {Plan}
     * @memberof UserPlan
     */
    plan: Plan;
    /**
     * 
     * @type {User}
     * @memberof UserPlan
     */
    user?: User;
    /**
     * 
     * @type {Array<UserPlanHistory>}
     * @memberof UserPlan
     */
    userPlanHistoryList?: Array<UserPlanHistory>;
}
/**
 * 
 * @export
 * @interface UserPlanHistory
 */
export interface UserPlanHistory {
    /**
     * 
     * @type {number}
     * @memberof UserPlanHistory
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof UserPlanHistory
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPlanHistory
     */
    createdAtString?: string;
    /**
     * 
     * @type {number}
     * @memberof UserPlanHistory
     */
    id: number;
    /**
     * 
     * @type {Plan}
     * @memberof UserPlanHistory
     */
    plan?: Plan;
    /**
     * 
     * @type {string}
     * @memberof UserPlanHistory
     */
    type: UserPlanHistoryTypeEnum;
    /**
     * 
     * @type {UserPlan}
     * @memberof UserPlanHistory
     */
    userPlan?: UserPlan;
}

/**
    * @export
    * @enum {string}
    */
export enum UserPlanHistoryTypeEnum {
    NEW = 'NEW',
    DELETE = 'DELETE',
    END = 'END',
    AGAIN = 'AGAIN',
    UP = 'UP',
    DOWN = 'DOWN'
}

/**
 * 
 * @export
 * @interface View
 */
export interface View {
    /**
     * 
     * @type {string}
     * @memberof View
     */
    contentType?: string;
}

/**
 * ArtistControllerApi - axios parameter creator
 * @export
 */
export const ArtistControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getArtistByTag
         * @param {string} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistByTagUsingGET(tag: string, options: any = {}): RequestArgs {
            // verify required parameter 'tag' is not null or undefined
            if (tag === null || tag === undefined) {
                throw new RequiredError('tag','Required parameter tag was null or undefined when calling getArtistByTagUsingGET.');
            }
            const localVarPath = `/api/artist/tag/{tag}`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getArtistList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistListUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/artist`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getArtist
         * @param {string} slug slug
         * @param {string} [state] state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistUsingGET(slug: string, state?: string, options: any = {}): RequestArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling getArtistUsingGET.');
            }
            const localVarPath = `/api/artist/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCategoryArtistList
         * @param {Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>} artistType artistType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryArtistListUsingGET(artistType: Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>, options: any = {}): RequestArgs {
            // verify required parameter 'artistType' is not null or undefined
            if (artistType === null || artistType === undefined) {
                throw new RequiredError('artistType','Required parameter artistType was null or undefined when calling getCategoryArtistListUsingGET.');
            }
            const localVarPath = `/api/artist/categoryArtist`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (artistType) {
                localVarQueryParameter['artistType'] = artistType;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtistControllerApi - functional programming interface
 * @export
 */
export const ArtistControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getArtistByTag
         * @param {string} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistByTagUsingGET(tag: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Artist>> {
            const localVarAxiosArgs = ArtistControllerApiAxiosParamCreator(configuration).getArtistByTagUsingGET(tag, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary getArtistList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistListUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Artist>> {
            const localVarAxiosArgs = ArtistControllerApiAxiosParamCreator(configuration).getArtistListUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary getArtist
         * @param {string} slug slug
         * @param {string} [state] state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistUsingGET(slug: string, state?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Artist> {
            const localVarAxiosArgs = ArtistControllerApiAxiosParamCreator(configuration).getArtistUsingGET(slug, state, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary getCategoryArtistList
         * @param {Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>} artistType artistType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryArtistListUsingGET(artistType: Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Artist>> {
            const localVarAxiosArgs = ArtistControllerApiAxiosParamCreator(configuration).getCategoryArtistListUsingGET(artistType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ArtistControllerApi - factory interface
 * @export
 */
export const ArtistControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getArtistByTag
         * @param {string} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistByTagUsingGET(tag: string, options?: any) {
            return ArtistControllerApiFp(configuration).getArtistByTagUsingGET(tag, options)(axios, basePath);
        },
        /**
         * 
         * @summary getArtistList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistListUsingGET(options?: any) {
            return ArtistControllerApiFp(configuration).getArtistListUsingGET(options)(axios, basePath);
        },
        /**
         * 
         * @summary getArtist
         * @param {string} slug slug
         * @param {string} [state] state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtistUsingGET(slug: string, state?: string, options?: any) {
            return ArtistControllerApiFp(configuration).getArtistUsingGET(slug, state, options)(axios, basePath);
        },
        /**
         * 
         * @summary getCategoryArtistList
         * @param {Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>} artistType artistType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryArtistListUsingGET(artistType: Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>, options?: any) {
            return ArtistControllerApiFp(configuration).getCategoryArtistListUsingGET(artistType, options)(axios, basePath);
        },
    };
};

/**
 * ArtistControllerApi - object-oriented interface
 * @export
 * @class ArtistControllerApi
 * @extends {BaseAPI}
 */
export class ArtistControllerApi extends BaseAPI {
    /**
     * 
     * @summary getArtistByTag
     * @param {string} tag tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistControllerApi
     */
    public getArtistByTagUsingGET(tag: string, options?: any) {
        return ArtistControllerApiFp(this.configuration).getArtistByTagUsingGET(tag, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary getArtistList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistControllerApi
     */
    public getArtistListUsingGET(options?: any) {
        return ArtistControllerApiFp(this.configuration).getArtistListUsingGET(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary getArtist
     * @param {string} slug slug
     * @param {string} [state] state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistControllerApi
     */
    public getArtistUsingGET(slug: string, state?: string, options?: any) {
        return ArtistControllerApiFp(this.configuration).getArtistUsingGET(slug, state, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary getCategoryArtistList
     * @param {Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>} artistType artistType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtistControllerApi
     */
    public getCategoryArtistListUsingGET(artistType: Array<'OTHER' | 'VTUBER' | 'YOUTUBER' | 'TALENT' | 'SPORTS' | 'GAME' | 'ANIME' | 'ENTERTAINER' | 'COMICS' | 'ARTIST' | 'SINGER' | 'VOICE_ACTOR' | 'CHARACTER' | 'LIVER' | 'ILLUSTRATOR' | 'EVENT'>, options?: any) {
        return ArtistControllerApiFp(this.configuration).getCategoryArtistListUsingGET(artistType, options)(this.axios, this.basePath);
    }

}


/**
 * BannerControllerApi - axios parameter creator
 * @export
 */
export const BannerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getBannerList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBannerListUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/banner`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannerControllerApi - functional programming interface
 * @export
 */
export const BannerControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getBannerList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBannerListUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Banner>> {
            const localVarAxiosArgs = BannerControllerApiAxiosParamCreator(configuration).getBannerListUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BannerControllerApi - factory interface
 * @export
 */
export const BannerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getBannerList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBannerListUsingGET(options?: any) {
            return BannerControllerApiFp(configuration).getBannerListUsingGET(options)(axios, basePath);
        },
    };
};

/**
 * BannerControllerApi - object-oriented interface
 * @export
 * @class BannerControllerApi
 * @extends {BaseAPI}
 */
export class BannerControllerApi extends BaseAPI {
    /**
     * 
     * @summary getBannerList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerControllerApi
     */
    public getBannerListUsingGET(options?: any) {
        return BannerControllerApiFp(this.configuration).getBannerListUsingGET(options)(this.axios, this.basePath);
    }

}


/**
 * CreditControllerApi - axios parameter creator
 * @export
 */
export const CreditControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary credit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/credit`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditControllerApi - functional programming interface
 * @export
 */
export const CreditControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary credit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormData> {
            const localVarAxiosArgs = CreditControllerApiAxiosParamCreator(configuration).creditUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CreditControllerApi - factory interface
 * @export
 */
export const CreditControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary credit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditUsingGET(options?: any) {
            return CreditControllerApiFp(configuration).creditUsingGET(options)(axios, basePath);
        },
    };
};

/**
 * CreditControllerApi - object-oriented interface
 * @export
 * @class CreditControllerApi
 * @extends {BaseAPI}
 */
export class CreditControllerApi extends BaseAPI {
    /**
     * 
     * @summary credit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditControllerApi
     */
    public creditUsingGET(options?: any) {
        return CreditControllerApiFp(this.configuration).creditUsingGET(options)(this.axios, this.basePath);
    }

}


/**
 * LoginControllerApi - axios parameter creator
 * @export
 */
export const LoginControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary emailLogin
         * @param {EmailPass} emailPass emailPass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailLoginUsingPOST(emailPass: EmailPass, options: any = {}): RequestArgs {
            // verify required parameter 'emailPass' is not null or undefined
            if (emailPass === null || emailPass === undefined) {
                throw new RequiredError('emailPass','Required parameter emailPass was null or undefined when calling emailLoginUsingPOST.');
            }
            const localVarPath = `/api/login/emailLogin`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"EmailPass" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(emailPass !== undefined ? emailPass : {}) : (emailPass || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary loginStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginStatusUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/login/loginStatus`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUsingDELETE(options: any = {}): RequestArgs {
            const localVarPath = `/api/login/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginControllerApi - functional programming interface
 * @export
 */
export const LoginControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary emailLogin
         * @param {EmailPass} emailPass emailPass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailLoginUsingPOST(emailPass: EmailPass, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginStatus> {
            const localVarAxiosArgs = LoginControllerApiAxiosParamCreator(configuration).emailLoginUsingPOST(emailPass, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary loginStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginStatusUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginStatus> {
            const localVarAxiosArgs = LoginControllerApiAxiosParamCreator(configuration).loginStatusUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUsingDELETE(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LoginControllerApiAxiosParamCreator(configuration).logoutUsingDELETE(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoginControllerApi - factory interface
 * @export
 */
export const LoginControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary emailLogin
         * @param {EmailPass} emailPass emailPass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailLoginUsingPOST(emailPass: EmailPass, options?: any) {
            return LoginControllerApiFp(configuration).emailLoginUsingPOST(emailPass, options)(axios, basePath);
        },
        /**
         * 
         * @summary loginStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginStatusUsingGET(options?: any) {
            return LoginControllerApiFp(configuration).loginStatusUsingGET(options)(axios, basePath);
        },
        /**
         * 
         * @summary logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUsingDELETE(options?: any) {
            return LoginControllerApiFp(configuration).logoutUsingDELETE(options)(axios, basePath);
        },
    };
};

/**
 * LoginControllerApi - object-oriented interface
 * @export
 * @class LoginControllerApi
 * @extends {BaseAPI}
 */
export class LoginControllerApi extends BaseAPI {
    /**
     * 
     * @summary emailLogin
     * @param {EmailPass} emailPass emailPass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginControllerApi
     */
    public emailLoginUsingPOST(emailPass: EmailPass, options?: any) {
        return LoginControllerApiFp(this.configuration).emailLoginUsingPOST(emailPass, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary loginStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginControllerApi
     */
    public loginStatusUsingGET(options?: any) {
        return LoginControllerApiFp(this.configuration).loginStatusUsingGET(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginControllerApi
     */
    public logoutUsingDELETE(options?: any) {
        return LoginControllerApiFp(this.configuration).logoutUsingDELETE(options)(this.axios, this.basePath);
    }

}


/**
 * MailControllerApi - axios parameter creator
 * @export
 */
export const MailControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary checkCode
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCodeUsingPOST(body: string, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling checkCodeUsingPOST.');
            }
            const localVarPath = `/api/mail/checkCode`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sendMail
         * @param {string} body 
         * @param {string} [langType] langType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailUsingPOST(body: string, langType?: string, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendMailUsingPOST.');
            }
            const localVarPath = `/api/mail/sendMail`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (langType !== undefined) {
                localVarQueryParameter['langType'] = langType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailControllerApi - functional programming interface
 * @export
 */
export const MailControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary checkCode
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCodeUsingPOST(body: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User> {
            const localVarAxiosArgs = MailControllerApiAxiosParamCreator(configuration).checkCodeUsingPOST(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary sendMail
         * @param {string} body 
         * @param {string} [langType] langType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailUsingPOST(body: string, langType?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = MailControllerApiAxiosParamCreator(configuration).sendMailUsingPOST(body, langType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MailControllerApi - factory interface
 * @export
 */
export const MailControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary checkCode
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCodeUsingPOST(body: string, options?: any) {
            return MailControllerApiFp(configuration).checkCodeUsingPOST(body, options)(axios, basePath);
        },
        /**
         * 
         * @summary sendMail
         * @param {string} body 
         * @param {string} [langType] langType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailUsingPOST(body: string, langType?: string, options?: any) {
            return MailControllerApiFp(configuration).sendMailUsingPOST(body, langType, options)(axios, basePath);
        },
    };
};

/**
 * MailControllerApi - object-oriented interface
 * @export
 * @class MailControllerApi
 * @extends {BaseAPI}
 */
export class MailControllerApi extends BaseAPI {
    /**
     * 
     * @summary checkCode
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailControllerApi
     */
    public checkCodeUsingPOST(body: string, options?: any) {
        return MailControllerApiFp(this.configuration).checkCodeUsingPOST(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary sendMail
     * @param {string} body 
     * @param {string} [langType] langType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailControllerApi
     */
    public sendMailUsingPOST(body: string, langType?: string, options?: any) {
        return MailControllerApiFp(this.configuration).sendMailUsingPOST(body, langType, options)(this.axios, this.basePath);
    }

}


/**
 * NewsControllerApi - axios parameter creator
 * @export
 */
export const NewsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getNewsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/news`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getNews
         * @param {number} newsId newsId
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsUsingGET(newsId: number, user?: string, options: any = {}): RequestArgs {
            // verify required parameter 'newsId' is not null or undefined
            if (newsId === null || newsId === undefined) {
                throw new RequiredError('newsId','Required parameter newsId was null or undefined when calling getNewsUsingGET.');
            }
            const localVarPath = `/api/news/{newsId}`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsControllerApi - functional programming interface
 * @export
 */
export const NewsControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getNewsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<News>> {
            const localVarAxiosArgs = NewsControllerApiAxiosParamCreator(configuration).getNewsListUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary getNews
         * @param {number} newsId newsId
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsUsingGET(newsId: number, user?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<News> {
            const localVarAxiosArgs = NewsControllerApiAxiosParamCreator(configuration).getNewsUsingGET(newsId, user, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewsControllerApi - factory interface
 * @export
 */
export const NewsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getNewsList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListUsingGET(options?: any) {
            return NewsControllerApiFp(configuration).getNewsListUsingGET(options)(axios, basePath);
        },
        /**
         * 
         * @summary getNews
         * @param {number} newsId newsId
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsUsingGET(newsId: number, user?: string, options?: any) {
            return NewsControllerApiFp(configuration).getNewsUsingGET(newsId, user, options)(axios, basePath);
        },
    };
};

/**
 * NewsControllerApi - object-oriented interface
 * @export
 * @class NewsControllerApi
 * @extends {BaseAPI}
 */
export class NewsControllerApi extends BaseAPI {
    /**
     * 
     * @summary getNewsList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsControllerApi
     */
    public getNewsListUsingGET(options?: any) {
        return NewsControllerApiFp(this.configuration).getNewsListUsingGET(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary getNews
     * @param {number} newsId newsId
     * @param {string} [user] user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsControllerApi
     */
    public getNewsUsingGET(newsId: number, user?: string, options?: any) {
        return NewsControllerApiFp(this.configuration).getNewsUsingGET(newsId, user, options)(this.axios, this.basePath);
    }

}


/**
 * PlanControllerApi - axios parameter creator
 * @export
 */
export const PlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPlan
         * @param {number} planId planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUsingGET(planId: number, options: any = {}): RequestArgs {
            // verify required parameter 'planId' is not null or undefined
            if (planId === null || planId === undefined) {
                throw new RequiredError('planId','Required parameter planId was null or undefined when calling getPlanUsingGET.');
            }
            const localVarPath = `/api/plan/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanControllerApi - functional programming interface
 * @export
 */
export const PlanControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPlan
         * @param {number} planId planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUsingGET(planId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan> {
            const localVarAxiosArgs = PlanControllerApiAxiosParamCreator(configuration).getPlanUsingGET(planId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PlanControllerApi - factory interface
 * @export
 */
export const PlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getPlan
         * @param {number} planId planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUsingGET(planId: number, options?: any) {
            return PlanControllerApiFp(configuration).getPlanUsingGET(planId, options)(axios, basePath);
        },
    };
};

/**
 * PlanControllerApi - object-oriented interface
 * @export
 * @class PlanControllerApi
 * @extends {BaseAPI}
 */
export class PlanControllerApi extends BaseAPI {
    /**
     * 
     * @summary getPlan
     * @param {number} planId planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanControllerApi
     */
    public getPlanUsingGET(planId: number, options?: any) {
        return PlanControllerApiFp(this.configuration).getPlanUsingGET(planId, options)(this.axios, this.basePath);
    }

}


/**
 * PlanOrderGoodsControllerApi - axios parameter creator
 * @export
 */
export const PlanOrderGoodsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPlanOrderGoods
         * @param {number} planOrderId planOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderGoodsUsingGET(planOrderId: number, options: any = {}): RequestArgs {
            // verify required parameter 'planOrderId' is not null or undefined
            if (planOrderId === null || planOrderId === undefined) {
                throw new RequiredError('planOrderId','Required parameter planOrderId was null or undefined when calling getPlanOrderGoodsUsingGET.');
            }
            const localVarPath = `/api/plan/order/{planOrderId}`
                .replace(`{${"planOrderId"}}`, encodeURIComponent(String(planOrderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanOrderGoodsControllerApi - functional programming interface
 * @export
 */
export const PlanOrderGoodsControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPlanOrderGoods
         * @param {number} planOrderId planOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderGoodsUsingGET(planOrderId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanOrderGoods>> {
            const localVarAxiosArgs = PlanOrderGoodsControllerApiAxiosParamCreator(configuration).getPlanOrderGoodsUsingGET(planOrderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PlanOrderGoodsControllerApi - factory interface
 * @export
 */
export const PlanOrderGoodsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getPlanOrderGoods
         * @param {number} planOrderId planOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderGoodsUsingGET(planOrderId: number, options?: any) {
            return PlanOrderGoodsControllerApiFp(configuration).getPlanOrderGoodsUsingGET(planOrderId, options)(axios, basePath);
        },
    };
};

/**
 * PlanOrderGoodsControllerApi - object-oriented interface
 * @export
 * @class PlanOrderGoodsControllerApi
 * @extends {BaseAPI}
 */
export class PlanOrderGoodsControllerApi extends BaseAPI {
    /**
     * 
     * @summary getPlanOrderGoods
     * @param {number} planOrderId planOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanOrderGoodsControllerApi
     */
    public getPlanOrderGoodsUsingGET(planOrderId: number, options?: any) {
        return PlanOrderGoodsControllerApiFp(this.configuration).getPlanOrderGoodsUsingGET(planOrderId, options)(this.axios, this.basePath);
    }

}


/**
 * PlanOrderHistoryControllerApi - axios parameter creator
 * @export
 */
export const PlanOrderHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPlanOrderHistoryList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderHistoryListUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/planOrderHistory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getPlanOrderHistory
         * @param {number} planOrderId planOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderHistoryUsingGET(planOrderId: number, options: any = {}): RequestArgs {
            // verify required parameter 'planOrderId' is not null or undefined
            if (planOrderId === null || planOrderId === undefined) {
                throw new RequiredError('planOrderId','Required parameter planOrderId was null or undefined when calling getPlanOrderHistoryUsingGET.');
            }
            const localVarPath = `/api/planOrderHistory/{planOrderId}`
                .replace(`{${"planOrderId"}}`, encodeURIComponent(String(planOrderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanOrderHistoryControllerApi - functional programming interface
 * @export
 */
export const PlanOrderHistoryControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPlanOrderHistoryList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderHistoryListUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanOrderHistory>> {
            const localVarAxiosArgs = PlanOrderHistoryControllerApiAxiosParamCreator(configuration).getPlanOrderHistoryListUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary getPlanOrderHistory
         * @param {number} planOrderId planOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderHistoryUsingGET(planOrderId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanOrderHistory> {
            const localVarAxiosArgs = PlanOrderHistoryControllerApiAxiosParamCreator(configuration).getPlanOrderHistoryUsingGET(planOrderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PlanOrderHistoryControllerApi - factory interface
 * @export
 */
export const PlanOrderHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getPlanOrderHistoryList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderHistoryListUsingGET(options?: any) {
            return PlanOrderHistoryControllerApiFp(configuration).getPlanOrderHistoryListUsingGET(options)(axios, basePath);
        },
        /**
         * 
         * @summary getPlanOrderHistory
         * @param {number} planOrderId planOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOrderHistoryUsingGET(planOrderId: number, options?: any) {
            return PlanOrderHistoryControllerApiFp(configuration).getPlanOrderHistoryUsingGET(planOrderId, options)(axios, basePath);
        },
    };
};

/**
 * PlanOrderHistoryControllerApi - object-oriented interface
 * @export
 * @class PlanOrderHistoryControllerApi
 * @extends {BaseAPI}
 */
export class PlanOrderHistoryControllerApi extends BaseAPI {
    /**
     * 
     * @summary getPlanOrderHistoryList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanOrderHistoryControllerApi
     */
    public getPlanOrderHistoryListUsingGET(options?: any) {
        return PlanOrderHistoryControllerApiFp(this.configuration).getPlanOrderHistoryListUsingGET(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary getPlanOrderHistory
     * @param {number} planOrderId planOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanOrderHistoryControllerApi
     */
    public getPlanOrderHistoryUsingGET(planOrderId: number, options?: any) {
        return PlanOrderHistoryControllerApiFp(this.configuration).getPlanOrderHistoryUsingGET(planOrderId, options)(this.axios, this.basePath);
    }

}


/**
 * RedirectControllerApi - axios parameter creator
 * @export
 */
export const RedirectControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary addRedirect
         * @param {Redirect} redirect redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRedirectUsingPOST(redirect: Redirect, options: any = {}): RequestArgs {
            // verify required parameter 'redirect' is not null or undefined
            if (redirect === null || redirect === undefined) {
                throw new RequiredError('redirect','Required parameter redirect was null or undefined when calling addRedirectUsingPOST.');
            }
            const localVarPath = `/api/redirect`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"Redirect" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(redirect !== undefined ? redirect : {}) : (redirect || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedirectControllerApi - functional programming interface
 * @export
 */
export const RedirectControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary addRedirect
         * @param {Redirect} redirect redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRedirectUsingPOST(redirect: Redirect, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Redirect> {
            const localVarAxiosArgs = RedirectControllerApiAxiosParamCreator(configuration).addRedirectUsingPOST(redirect, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RedirectControllerApi - factory interface
 * @export
 */
export const RedirectControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary addRedirect
         * @param {Redirect} redirect redirect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRedirectUsingPOST(redirect: Redirect, options?: any) {
            return RedirectControllerApiFp(configuration).addRedirectUsingPOST(redirect, options)(axios, basePath);
        },
    };
};

/**
 * RedirectControllerApi - object-oriented interface
 * @export
 * @class RedirectControllerApi
 * @extends {BaseAPI}
 */
export class RedirectControllerApi extends BaseAPI {
    /**
     * 
     * @summary addRedirect
     * @param {Redirect} redirect redirect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedirectControllerApi
     */
    public addRedirectUsingPOST(redirect: Redirect, options?: any) {
        return RedirectControllerApiFp(this.configuration).addRedirectUsingPOST(redirect, options)(this.axios, this.basePath);
    }

}


/**
 * UserControllerApi - axios parameter creator
 * @export
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary postUser
         * @param {User} inputUser inputUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUsingPOST(inputUser: User, options: any = {}): RequestArgs {
            // verify required parameter 'inputUser' is not null or undefined
            if (inputUser === null || inputUser === undefined) {
                throw new RequiredError('inputUser','Required parameter inputUser was null or undefined when calling postUserUsingPOST.');
            }
            const localVarPath = `/api/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"User" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inputUser !== undefined ? inputUser : {}) : (inputUser || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary putLoginPass
         * @param {EmailPass} emailPass emailPass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLoginPassUsingPUT(emailPass: EmailPass, options: any = {}): RequestArgs {
            // verify required parameter 'emailPass' is not null or undefined
            if (emailPass === null || emailPass === undefined) {
                throw new RequiredError('emailPass','Required parameter emailPass was null or undefined when calling putLoginPassUsingPUT.');
            }
            const localVarPath = `/api/user/loginPass`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"EmailPass" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(emailPass !== undefined ? emailPass : {}) : (emailPass || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary putUser
         * @param {User} inputUser inputUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserUsingPUT(inputUser: User, options: any = {}): RequestArgs {
            // verify required parameter 'inputUser' is not null or undefined
            if (inputUser === null || inputUser === undefined) {
                throw new RequiredError('inputUser','Required parameter inputUser was null or undefined when calling putUserUsingPUT.');
            }
            const localVarPath = `/api/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"User" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inputUser !== undefined ? inputUser : {}) : (inputUser || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary userDelete
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeleteUsingDELETE(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling userDeleteUsingDELETE.');
            }
            const localVarPath = `/api/user`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 * @export
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User> {
            const localVarAxiosArgs = UserControllerApiAxiosParamCreator(configuration).getUserUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary postUser
         * @param {User} inputUser inputUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUsingPOST(inputUser: User, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User> {
            const localVarAxiosArgs = UserControllerApiAxiosParamCreator(configuration).postUserUsingPOST(inputUser, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary putLoginPass
         * @param {EmailPass} emailPass emailPass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLoginPassUsingPUT(emailPass: EmailPass, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserControllerApiAxiosParamCreator(configuration).putLoginPassUsingPUT(emailPass, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary putUser
         * @param {User} inputUser inputUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserUsingPUT(inputUser: User, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User> {
            const localVarAxiosArgs = UserControllerApiAxiosParamCreator(configuration).putUserUsingPUT(inputUser, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary userDelete
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeleteUsingDELETE(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserControllerApiAxiosParamCreator(configuration).userDeleteUsingDELETE(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserControllerApi - factory interface
 * @export
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary getUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUsingGET(options?: any) {
            return UserControllerApiFp(configuration).getUserUsingGET(options)(axios, basePath);
        },
        /**
         * 
         * @summary postUser
         * @param {User} inputUser inputUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUsingPOST(inputUser: User, options?: any) {
            return UserControllerApiFp(configuration).postUserUsingPOST(inputUser, options)(axios, basePath);
        },
        /**
         * 
         * @summary putLoginPass
         * @param {EmailPass} emailPass emailPass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putLoginPassUsingPUT(emailPass: EmailPass, options?: any) {
            return UserControllerApiFp(configuration).putLoginPassUsingPUT(emailPass, options)(axios, basePath);
        },
        /**
         * 
         * @summary putUser
         * @param {User} inputUser inputUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserUsingPUT(inputUser: User, options?: any) {
            return UserControllerApiFp(configuration).putUserUsingPUT(inputUser, options)(axios, basePath);
        },
        /**
         * 
         * @summary userDelete
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeleteUsingDELETE(userId: number, options?: any) {
            return UserControllerApiFp(configuration).userDeleteUsingDELETE(userId, options)(axios, basePath);
        },
    };
};

/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
export class UserControllerApi extends BaseAPI {
    /**
     * 
     * @summary getUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getUserUsingGET(options?: any) {
        return UserControllerApiFp(this.configuration).getUserUsingGET(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary postUser
     * @param {User} inputUser inputUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public postUserUsingPOST(inputUser: User, options?: any) {
        return UserControllerApiFp(this.configuration).postUserUsingPOST(inputUser, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary putLoginPass
     * @param {EmailPass} emailPass emailPass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public putLoginPassUsingPUT(emailPass: EmailPass, options?: any) {
        return UserControllerApiFp(this.configuration).putLoginPassUsingPUT(emailPass, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary putUser
     * @param {User} inputUser inputUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public putUserUsingPUT(inputUser: User, options?: any) {
        return UserControllerApiFp(this.configuration).putUserUsingPUT(inputUser, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary userDelete
     * @param {number} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public userDeleteUsingDELETE(userId: number, options?: any) {
        return UserControllerApiFp(this.configuration).userDeleteUsingDELETE(userId, options)(this.axios, this.basePath);
    }

}


/**
 * UserPlanControllerApi - axios parameter creator
 * @export
 */
export const UserPlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary deleteUserPlan
         * @param {number} planId planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPlanUsingDELETE(planId: number, options: any = {}): RequestArgs {
            // verify required parameter 'planId' is not null or undefined
            if (planId === null || planId === undefined) {
                throw new RequiredError('planId','Required parameter planId was null or undefined when calling deleteUserPlanUsingDELETE.');
            }
            const localVarPath = `/api/userPlan/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getUserPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPlanUsingGET(options: any = {}): RequestArgs {
            const localVarPath = `/api/userPlan`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary postUserPlan
         * @param {UserPlan} userPlan userPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPlanUsingPOST(userPlan: UserPlan, options: any = {}): RequestArgs {
            // verify required parameter 'userPlan' is not null or undefined
            if (userPlan === null || userPlan === undefined) {
                throw new RequiredError('userPlan','Required parameter userPlan was null or undefined when calling postUserPlanUsingPOST.');
            }
            const localVarPath = `/api/userPlan`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UserPlan" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userPlan !== undefined ? userPlan : {}) : (userPlan || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary putUserPlan
         * @param {UserPlan} inputUserPlan inputUserPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserPlanUsingPUT(inputUserPlan: UserPlan, options: any = {}): RequestArgs {
            // verify required parameter 'inputUserPlan' is not null or undefined
            if (inputUserPlan === null || inputUserPlan === undefined) {
                throw new RequiredError('inputUserPlan','Required parameter inputUserPlan was null or undefined when calling putUserPlanUsingPUT.');
            }
            const localVarPath = `/api/userPlan`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UserPlan" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inputUserPlan !== undefined ? inputUserPlan : {}) : (inputUserPlan || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPlanControllerApi - functional programming interface
 * @export
 */
export const UserPlanControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary deleteUserPlan
         * @param {number} planId planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPlanUsingDELETE(planId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserPlanControllerApiAxiosParamCreator(configuration).deleteUserPlanUsingDELETE(planId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary getUserPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPlanUsingGET(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserPlan>> {
            const localVarAxiosArgs = UserPlanControllerApiAxiosParamCreator(configuration).getUserPlanUsingGET(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary postUserPlan
         * @param {UserPlan} userPlan userPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPlanUsingPOST(userPlan: UserPlan, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPlan> {
            const localVarAxiosArgs = UserPlanControllerApiAxiosParamCreator(configuration).postUserPlanUsingPOST(userPlan, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary putUserPlan
         * @param {UserPlan} inputUserPlan inputUserPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserPlanUsingPUT(inputUserPlan: UserPlan, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserPlanControllerApiAxiosParamCreator(configuration).putUserPlanUsingPUT(inputUserPlan, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserPlanControllerApi - factory interface
 * @export
 */
export const UserPlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary deleteUserPlan
         * @param {number} planId planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPlanUsingDELETE(planId: number, options?: any) {
            return UserPlanControllerApiFp(configuration).deleteUserPlanUsingDELETE(planId, options)(axios, basePath);
        },
        /**
         * 
         * @summary getUserPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPlanUsingGET(options?: any) {
            return UserPlanControllerApiFp(configuration).getUserPlanUsingGET(options)(axios, basePath);
        },
        /**
         * 
         * @summary postUserPlan
         * @param {UserPlan} userPlan userPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPlanUsingPOST(userPlan: UserPlan, options?: any) {
            return UserPlanControllerApiFp(configuration).postUserPlanUsingPOST(userPlan, options)(axios, basePath);
        },
        /**
         * 
         * @summary putUserPlan
         * @param {UserPlan} inputUserPlan inputUserPlan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserPlanUsingPUT(inputUserPlan: UserPlan, options?: any) {
            return UserPlanControllerApiFp(configuration).putUserPlanUsingPUT(inputUserPlan, options)(axios, basePath);
        },
    };
};

/**
 * UserPlanControllerApi - object-oriented interface
 * @export
 * @class UserPlanControllerApi
 * @extends {BaseAPI}
 */
export class UserPlanControllerApi extends BaseAPI {
    /**
     * 
     * @summary deleteUserPlan
     * @param {number} planId planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPlanControllerApi
     */
    public deleteUserPlanUsingDELETE(planId: number, options?: any) {
        return UserPlanControllerApiFp(this.configuration).deleteUserPlanUsingDELETE(planId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary getUserPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPlanControllerApi
     */
    public getUserPlanUsingGET(options?: any) {
        return UserPlanControllerApiFp(this.configuration).getUserPlanUsingGET(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary postUserPlan
     * @param {UserPlan} userPlan userPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPlanControllerApi
     */
    public postUserPlanUsingPOST(userPlan: UserPlan, options?: any) {
        return UserPlanControllerApiFp(this.configuration).postUserPlanUsingPOST(userPlan, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary putUserPlan
     * @param {UserPlan} inputUserPlan inputUserPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPlanControllerApi
     */
    public putUserPlanUsingPUT(inputUserPlan: UserPlan, options?: any) {
        return UserPlanControllerApiFp(this.configuration).putUserPlanUsingPUT(inputUserPlan, options)(this.axios, this.basePath);
    }

}


